import CurrencyRatePage from '@/pages/components/tools/currency-rate/CurrencyRatePage';

export default {
    list: CurrencyRatePage,
};
